<template>
  <div :class="$store.getters.platform === 'browser' ? 'page-bg-browser' : 'page-bg'" v-bg="{image: product.background, alternative: true, dir: 'to right'}">

    <app-loader v-if="loading"></app-loader>
    <div v-else>

      <div :id="'prod-' + product.id" class="wrapper-data">

        <div class="img">
          <img :src="$store.getters.getData.logo_mono">
        </div>

        <div class="data" :style="{ 'border-top-color': $store.getters.getData.color1 }">
          <div class="row" style="padding: 0 1rem 0 1rem;">
            <div class="col s3" style="padding: 0;">
              <div class="a1by1 product-img" :style="{ 'background-image': 'url(' + product.image + ')' }"></div>
            </div>
            <div class="col s12 m9">
              <div class="row">

                <div class="col s12">
                  <h2>{{product.name}}</h2>
                  <p>{{product.description | truncateText(500)}}</p>
                </div>

                <div v-if="!soldOut" class="col s8 wrapper-features">
                  <a @click="action('mod-quantity')" @keyup.enter="action('mod-quantity')" class="waves-effect waves-light btn focusable" tabindex="-1">
                    <span>{{ $t("SHOP.QUANTITY") }}: </span><span>{{quantity}}</span>
                    <span v-if="stock<quantity">({{ $t('SHOP.NO-STOCK') }})</span>
                  </a>
                  <a v-for="feature in features" :key="feature.id" @click="action('mod-feature', feature)" @keyup.enter="action('mod-feature', feature)" class="waves-effect waves-light btn focusable" tabindex="-1" >
                    <span>{{feature.name}}: </span>
                    <span>{{feature.value_name}}</span>
                  </a>

                  <span class="msg-unavailable" v-bind:class="{ unavailable: isUnavailable }">{{ $t('SHOP.MSG-UNAVAILABLE') }}</span>
                </div>

                <div v-else class="col s8 wrapper-features"> <span class="danger-text">{{$t('SHOP.SOLD-OUT')}}</span></div>

                <div class="col s4" style="text-align: right;">
                  <span v-if="priceOld" class="price-old danger-text">{{ priceOld | currency }}</span><br>
                  <span class="price">{{price | currency }}</span>
                </div>

                <div v-if="!soldOut" class="col s12">
                  <a v-on:click="action('add')" v-on:keyup.enter="action('add')" class="waves-effect waves-light btn-large focusable" tabindex="-1" style="margin-bottom: .3rem">
                    <span v-if='!waiting'>{{ $t("SHOP.ADD") }}</span>
                    <icon v-else name="sync" spin scale='1.8'></icon>
                  </a>
                  <a v-on:click="action('purchase')" v-on:keyup.enter="action('purchase')" class="waves-effect waves-light btn-large focusable" tabindex="-1" style="margin-bottom: .3rem">{{ $t("SHOP.DIRECT") }}</a>
                </div>

                <Modal v-if="showModal" @close="closeModal">
                   <!-- modal dialog -->
                  <p v-if="showModal === 'dialog'" slot="body" class="modal-text">{{textDialog}}</p>

                   <!-- modal no user -->
                  <Login v-if="showModal === 'no-user'"
                    slot="body"
                    :title="''"
                    :redirect="false"
                    @onLogin="loggedIn"
                  />
                  <a v-if="showModal === 'no-user'" slot="footer" @click="closeModal" v-on:keyup.enter="closeModal" class="waves-effect waves-light btn-large modal-focusable" tabindex="-1">{{ $t("GENERAL.CANCEL") }}</a>

                  <!-- modal form quantity -->
                  <span v-if="showModal === 'form-quantity'" slot="header">{{ $t("SHOP.QUANTITY") }}</span>
                  <div v-if="showModal === 'form-quantity'" slot="body">
                    <div class="wrapper-features wrapper-features-focusable" @keyup.left="decreaseQuantity" @keyup.right="increaseQuantity" @keyup.enter="setQuantity">
                      <a class="waves-effect waves-light btn btn-quantity">
                        <button @click="decreaseQuantity" class="wrapper-icon"><icon name="caret-left" class='icon'></icon></button>
                        <span>{{quantityForm}}</span>
                        <button @click="increaseQuantity" class="wrapper-icon"><icon name="caret-right" class='icon'></icon></button>

                      </a>
                    </div>
                  </div>
                  <div v-if="showModal === 'form-quantity'" slot="footer">
                    <a @click="setQuantity" v-on:keyup.enter="setQuantity" class="waves-effect waves-light btn-large modal-focusable" tabindex="-1">{{ $t("GENERAL.ACCEPT") }}</a>
                  </div>

                  <!-- modal form feature -->
                  <span v-if="showModal === 'form-feature'" slot="header">{{featureForm.name}}</span>
                  <div v-if="showModal === 'form-feature'" slot="body">
                    <div class="wrapper-features">
                      <a v-for="option in featureForm.options" :key="option.id"
                        @click="setValueFeature(featureForm.id, option)"
                        @keyup.enter="setValueFeature(featureForm.id, option)"
                        :class="{'disabled': !option.stock, 'modal-focusable': option.stock }" class="waves-effect waves-light btn" tabindex="-1" >
                        {{option.name}}
                        <span v-if="!option.stock" class="danger-text">({{$t('SHOP.SOLD-OUT')}})</span>
                      </a>
                    </div>
                  </div>
                  <div v-if="showModal === 'form-feature'" slot="footer">
                    <a @click="closeModal" v-on:keyup.enter="closeModal" class="waves-effect waves-light btn-large modal-focusable" tabindex="-1">{{ $t("GENERAL.CANCEL") }}</a>
                  </div>

                </Modal>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- control bar -->
      <ControlBar v-if="$store.getters.getData.control_bar && $store.getters.platform !== 'browser'" :keys="keys" />

    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import axios from 'axios'
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import SpatialNavigation from 'js-spatial-navigation'
import Modal from '@/components/Modal'
import ControlBar from '@/components/ControlBar'
import {StatsProductDetail} from '@/utils/constants'
import Login from '@/components/Login'
const productsService = require('@/services/products.js')

export default {
  name: 'ProductDetail',
  components: {
    'app-loader': Loader,
    Modal,
    Login,
    ControlBar
  },
  data () {
    return {
      product: {},
      quantity: 1,
      features: [],
      price: null,
      priceOld: null,
      stock: null,
      soldOut: null,
      isUnavailable: false, // disponibilidad de combinaciones

      featureForm: null,
      quantityForm: 1,

      showModal: false,
      textDialog: '',

      waiting: false,

      keys: [
        {text: this.$i18n.t('KEYS.BACK'), action: this.$i18n.t('KEYS.RETURN')},
        {text: this.$i18n.t('KEYS.OK'), action: this.$i18n.t('KEYS.SELECT')},
        {color: 'yellow', action: this.$i18n.t('KEYS.HOME')}
      ]
    }
  },
  beforeCreate: function () {
    document.querySelector('body').style.overflowY = 'hidden'
  },
  created: function () {
    // PRODUCTO
    if (this.$store.getters.getData.type_shop === 'A2C') {
      // tienda API2CART
      axios.all([productsService.productsA2C({id: this.$route.params.id}), productsService.getCombinations({product_id: this.$route.params.id})]).then(axios.spread((dataProduct, dataCombinations) => {
        let img = dataProduct.data.images.filter((a) => (a.type === 'IMAGE_TYPE_BASE'))[0]
        let model = (dataProduct.data.u_model) ? dataProduct.data.u_model : ' '

        let product = {
          id: dataProduct.data.id,
          name: dataProduct.data.name,
          description: dataProduct.data.short_description.replace(/<\/?[^>]+>/ig, ' '),
          image: img.http_path,
          baseImage: img.http_path,
          price: dataProduct.data.price,
          stock: dataProduct.data.quantity,
          model: model,
          options: dataProduct.data.product_options,
          combinations: dataCombinations.data.children,
          special_price: dataProduct.data.special_price
        }

        this.product = product
        this.initFeatures()
        setTimeout(() => this.initControls())
        window.Countly.q.push(['track_pageview', StatsProductDetail + ' ' + this.product.id + ': ' + this.product.name])
      }))
    } else {
      // tienda interna
      productsService.getProduct(this.$route.params.id).then(response => {
        this.product = response.data

        this.initFeatures()
        setTimeout(() => this.initControls())
        window.Countly.q.push(['track_pageview', StatsProductDetail + ' ' + this.product.id + ': ' + this.product.name])
      })
    }
  },
  mounted: function () {
    // control keys
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-yellow', this.keyYellow)
  },
  methods: {
    initControls () {
      if (!this.soldOut) {
        this.SN = SpatialNavigation.add({selector: '#prod-' + this.product.id + ' .focusable', restrict: 'self-only'})
        SpatialNavigation.makeFocusable(this.SN)

        SpatialNavigation.focus(this.SN)
        SpatialNavigation.resume()
      }
    },
    action (action, feature) {
      if (!this.$store.getters.user) {
        if (this.$store.getters.platform !== 'browser') {
          this.showModal = 'no-user'
        } else {
          this.textDialog = this.$i18n.t('GENERAL.REQUIERE-LINK')
          this.showModal = 'dialog'
        }
      } else {
        if (action === 'mod-quantity') {
          this.quantityForm = this.quantity
          this.showModal = 'form-quantity'
        } else if (action === 'mod-feature') {
          let options = []
          for (let i = 0; i < feature.options.length; i++) {
            let name = feature.options[i].value ? feature.options[i].value.value : feature.options[i].name
            let value = feature.options[i].value ? feature.options[i].value : false
            let stock = feature.options[i].stock ? feature.options[i].stock : true

            options.push({
              id: feature.options[i].id,
              name: name,
              value: value,
              stock: stock
            })
          }

          this.featureForm = {
            id: feature.id,
            name: feature.name,
            options: options
          }

          this.showModal = 'form-feature'
        } else if (action === 'add' && !this.waiting) {
          if (this.isUnavailable) {
            M.toast({html: this.$i18n.t('SHOP.MSG-UNAVAILABLE'), classes: 'red lighten-1'})
          } else {
            SpatialNavigation.pause()
            this.waiting = true

            if (this.$store.getters.getData.type_shop === 'A2C') {
              // compra api2cart
              let options = []
              for (let i = 0; i < this.features.length; i++) {
                options.push({
                  option_id: this.features[i].id,
                  selected_option: this.features[i].value_id
                })
              }

              let product = {
                product_id: this.product.id,
                product_quantity: this.quantity,
                options: options
              }

              productsService.addProductToCartA2C(product)
                .then(response => {
                  SpatialNavigation.resume()
                  this.waiting = false
                  this.textDialog = this.$i18n.t('SHOP.BODY-ADD')
                  this.showModal = 'dialog'
                }).catch(() => {
                  SpatialNavigation.resume()
                  this.waiting = false
                })
            } else {
              // compra interna
              let options = []
              for (let i = 0; i < this.features.length; i++) {
                options.push({
                  feature: this.features[i].id,
                  selected_value: this.features[i].value_id
                })
              }

              let product = {
                product: this.product.id,
                features: options,
                quantity: this.quantity
              }

              productsService.addProductToCart(product)
                .then(response => {
                  SpatialNavigation.resume()
                  this.waiting = false
                  this.textDialog = this.$i18n.t('SHOP.BODY-ADD')
                  this.showModal = 'dialog'
                }).catch(() => {
                  SpatialNavigation.resume()
                  this.waiting = false
                })
            }
          }
        } else if (action === 'purchase') {
          if (this.isUnavailable) {
            M.toast({html: this.$i18n.t('SHOP.MSG-UNAVAILABLE'), classes: 'red lighten-1'})
          } else {
            if (this.$store.getters.getData.type_shop === 'A2C') {
              // compra api2cart
              let params = {
                order_payment_method: 'Pago desde plataforma externa de TV', // *** quitar
                order_item_id_1: this.product.id,
                order_item_quantity_1: this.quantity,
                order_item_name_1: this.product.name,
                order_item_model_1: this.product.model,
                order_item_price_1: this.price
              }

              for (let i = 0; i < this.features.length; i++) {
                params['order_item_option_name_1_' + (i + 1)] = this.features[i].name
                params['order_item_option_value_1_' + (i + 1)] = this.features[i].value_name
                params['order_item_option_price_1_' + (i + 1)] = 0 // this.features[i].value_price
              }

              this.$store.commit('setPurchase', {
                type: 'pro',
                params: params
              })
            } else {
              // compra interna
              let options = []
              for (let i = 0; i < this.features.length; i++) {
                options.push({
                  feature: this.features[i].id,
                  selected_value: this.features[i].value_id
                })
              }

              if (!this.product.product_features.length) {
                this.$store.commit('setPurchase', {
                  type: 'pro',
                  id: this.product.id,
                  id_feature: '',
                  price: this.product.price,
                  quantity: this.quantity,
                  features: options
                })
              } else {
                // backend envía de forma 'especial' las features nuevas
                let id = this.features[0].options.filter((a) => (a.value.id === options[0].selected_value))[0].id

                this.$store.commit('setPurchase', {
                  type: 'pro',
                  id: this.product.id,
                  id_feature: id,
                  price: this.price,
                  quantity: this.quantity,
                  features: options
                })
              }
            }
            this.$router.push({name: 'purchase-summary-product'})
          }
        }
      }
    },
    initFeatures () {
      if (this.$store.getters.getData.type_shop === 'A2C') {
        // tienda api2cart

        // opciones(talla, color...) y sus valores(L, M, rojo...)
        for (let i = 0; i < this.product.options.length; ++i) {
          let options = []
          for (let j = 0; j < this.product.options[i].option_items.length; j++) {
            options.push({
              id: this.product.options[i].option_items[j].id,
              name: this.product.options[i].option_items[j].name
            })
          }

          let features = {
            id: this.product.options[i].id,
            name: this.product.options[i].name,
            value_id: this.product.options[i].option_items[0].id,
            value_name: this.product.options[i].option_items[0].name,
            value_price: this.product.options[i].option_items[0].price,
            options: options
          }
          this.features.push(features)
        }

        // si un producto tiene options tiene que tener combinations
        if (this.product.combinations.length) {
          // producto con combinaciones
          this.setCombination(this.features)
        } else if (this.product.special_price && this.product.special_price.avail) {
          // producto sin combinaciones con special price
          this.priceOld = this.product.price
          this.price = this.product.special_price.value
        } else {
          // producto sin combinaciones ni special price
          this.price = this.product.price
        }

        this.stock = this.product.stock
        this.soldOut = !(this.stock > 0)
      } else {
        // tienda interna
        if (!this.product.product_features.length) {
          // features antiguas
          for (let i = 0; i < this.product.features.length; ++i) {
            let options = []
            for (let j = 0; j < this.product.features[i].values.length; j++) {
              options.push({
                id: this.product.features[i].values[j].id,
                name: this.product.features[i].values[j].value
              })
            }

            let features = {
              id: this.product.features[i].id,
              name: this.product.features[i].name,
              value_id: this.product.features[i].values[0].id,
              value_name: this.product.features[i].values[0].value,
              options: options
            }
            this.features.push(features)
          }

          // valores iniciales
          this.price = this.product.price
          this.priceOld = this.product.price_old
          this.stock = this.product.stock
          this.soldOut = !(this.stock > 0)
        } else {
          // features nuevas
          let initial = {id: null, value: { value: null }}
          for (let i = 0; i < this.product.product_features.length; ++i) {
            let options = []
            for (let j = 0; j < this.product.product_features[i].feature_values.length; j++) {
              options.push({
                id: this.product.product_features[i].feature_values[j].id,
                value: this.product.product_features[i].feature_values[j].value,
                stock: this.product.product_features[i].feature_values[j].stock,
                price: this.product.product_features[i].feature_values[j].price
              })

              // inicial
              if (!initial.id && this.product.product_features[i].feature_values[j].stock) {
                initial = this.product.product_features[i].feature_values[j]
              }
            }

            let features = {
              id: this.product.product_features[i].id,
              name: this.product.product_features[i].name,
              value_id: initial.value.id,
              value_name: initial.value.value,
              options: options
            }
            this.features.push(features)
          }
          // valores iniciales
          if (initial.id) {
            this.price = initial.price
            // this.priceOld = this.product.price_old
            this.stock = initial.stock
          } else {
            this.price = this.product.product_features[0].feature_values[0].price
            // this.priceOld = this.product.price_old
            this.stock = 0
          }
          this.soldOut = !(this.stock > 0)
        }
      }
    },
    setCombination: function (features) {
      for (let i = 0; i < this.product.combinations.length; i++) {
        let isCurrentCombination = true
        for (let j = 0; j < this.product.combinations[i].combination.length; j++) {
          // comprobamos si la feature tiene el valor de la combinación
          let feature = this.features.filter((a) => (a.id === this.product.combinations[i].combination[j].option_id && a.value_id === this.product.combinations[i].combination[j].option_value_id))[0]

          // si no hay ninguna coincidencia salimos del for -> no puede ser esta combinación
          if (!feature) {
            isCurrentCombination = false
            break
          }
        }

        // si encontramos una combinación positiva salimos del for
        if (isCurrentCombination) {
          this.price = this.product.combinations[i].default_price
          this.isUnavailable = !this.product.combinations[i].avail_for_sale
          this.product.image = this.product.combinations[i].images.length ? this.product.combinations[i].images[0].http_path : this.product.baseImage

          let price = this.product.combinations[i].default_price
          let priceOld = false
          for (let k = 0; k < this.product.combinations[i].advanced_price.length; k++) {
            if (this.product.combinations[i].advanced_price[k].avail && !priceOld) {
              priceOld = this.product.combinations[i].default_price
              price = this.product.combinations[i].advanced_price[k].value
            }
          }
          this.price = price
          this.priceOld = priceOld
          break
        }
      }
    },
    decreaseQuantity: function () {
      if (this.quantityForm > 1) this.quantityForm--
    },
    increaseQuantity: function () {
      if (this.quantityForm < this.stock) this.quantityForm++
    },
    setQuantity: function () {
      this.quantity = this.quantityForm
      this.closeModal(false)
    },
    setValueFeature: function (idFeature, option) {
      let feature = this.features.filter((a) => (a.id === idFeature))[0]
      let valueId = option.value ? option.value.id : option.id

      feature.value_id = valueId
      feature.value_name = option.name

      // combinaciones
      if (this.product.combinations && this.product.combinations.length) { this.setCombination(this.features) }

      this.closeModal(false)
    },
    closeModal: function (event) {
      this.showModal = false
      SpatialNavigation.focus(this.SN)
    },
    loggedIn: function () {
      this.textDialog = this.$i18n.t('LOGIN.WELCOME')
      this.showModal = 'dialog'
    },
    keyBack: function () {
      if (!document.getElementById('app-modal')) {
        this.$router.go(-1)
      }
    },
    keyYellow: function () { if (this.$store.getters.getData.control_bar && this.$store.getters.platform !== 'browser') this.$router.push({name: 'content'}) }
  },
  computed: {
    loading: function () {
      return Object.keys(this.product).length === 0
    }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-yellow', this.keyYellow)
    if (this.SN) SpatialNavigation.remove(this.SN)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>

.wrapper-data
  position: relative;
  min-height: 22vh

  .img
    float: right;
    max-width: 22vw;
    max-height: inherit;
    padding-right: 2rem;
    margin-top: 1rem;
    padding-bottom: 4rem;
    min-width: 156px;

    img
      max-width: 100%;
      height: auto;
      max-height: inherit;

  .data
    clear: both;
    background: white
    margin: 0 2rem 0 2rem

    // border-top-color: black
    border-top-width: .3rem
    border-top-style: solid

    .product-img
      background-position: center center
      background-repeat: no-repeat
      background-size: cover

    h2
      font-weight: bold
      font-size: 2rem

    p:not(.modal-text)
      font-size: 1.2rem

    .wrapper-features
      display: flex
      flex-direction: column
      margin-bottom: 1.5rem

      .btn
        width: fit-content
        margin-bottom: .8rem

        span:first-child
          font-weight: bold

        .danger-text
          font-size: 1rem !important

      .danger-text
        font-size: 1.8rem

      .wrapper-icon
        background-color: transparent
        background-repeat: no-repeat
        border: none
        cursor: pointer
        overflow: hidden
        outline: none

        .icon
          font-size: 4rem

    .wrapper-features-focusable
      outline: none

    .price-old
      text-decoration: line-through
      font-size: 2.1rem

    .price
      font-weight: bold
      font-size: 2.1rem

.danger-text
  color: red!important

.btn-quantity
  display: flex
  display: -webkit-flex

  span
    margin-left: 1rem
    margin-right: 1rem

.msg-unavailable
  visibility: hidden
  font-size: 1rem
  color: red

.msg-unavailable.unavailable
  visibility: visible!important

@media screen and (max-width: 576px)
  .data
    margin: 0 .2rem 0 .2rem !important

</style>



// WEBPACK FOOTER //
// src/pages/products/ProductDetail.vue